import { defineStore } from 'pinia';

import { UserType } from '@/types/api/NewUser/User';
import { Role } from '@/types/enum/user';
import { Domain } from '@/types/api/Business/Domain';

export const useUserStore = defineStore('userStore', {
  state: () => ({
    isAuthenticating: true as boolean,
    user: null as UserType | null,
    roles: [] as Role[],
    domain: null as Domain | null,
    isAuthenticated: false as boolean,
    productTypeId: null as number | null,
  }),
  actions: {
    setUser(user: UserType | null) {      
      this.user = user;
    },
    setRoles(roles: Role[]) {
      this.roles = roles;
    },
    setIsAuthenticating(isAuthenticating: boolean) {
      this.isAuthenticating = isAuthenticating;
    },
    setDomain(domain: Domain | null) {
      this.domain = domain;
    },
    setIsAuthenticated(isAuthenticated: boolean) {
      this.isAuthenticated = isAuthenticated;
    },
  },
});

export type UseUserStore = ReturnType<typeof useUserStore>;
